export default {
  'memberArea.title': '会員専用エリア',
  'memberArea.to_next_level': '次のランクアップまで',
  'memberArea.member_info': '会員情報',
  'memberArea.invoice_carrier': 'レシートツール',
  'memberArea.language': '言語',
} as Record<string, string>;
